import React, { useState, useEffect } from 'react';

const PopupModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const popupDisplayed = localStorage.getItem('popupDisplayed');
    if (!popupDisplayed) {
      setIsVisible(true);
    }
  }, []);

  const closePopup = () => {
    setIsVisible(false);
    localStorage.setItem('popupDisplayed', 'true');
  };

  const openExternalLink = () => {
    window.open('https://t.me/trendingbrazil', '_blank');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <style>
        {`
          #popup-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            opacity: 1;
            transition: opacity 0.3s ease;
          }

          #popup-container.popup-hidden {
            display: none;
          }

          .popup-content {
            background: url('https://4kwallpapers.com/images/walls/thumbs_3t/13833.jpg') no-repeat center center;
            background-size: cover;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
            color: white;
          }

          .popup-content h2 {
            margin: 0 0 10px 0;
          }

          .popup-content button {
            background: #007BFF;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
          }

          .popup-content button:hover {
            background: #0056B3;
          }
        `}
      </style>
      
      <div id="popup-container" className={isVisible ? '' : 'popup-hidden'}>
        <div className="popup-content">
          <h2 style={{backgroundColor:'black', padding:'10px'}}>
            ENTRE NA NOSSA SALA DE SINAIS <b style={{color:'red'}}>AO VIVO!</b>
          </h2>
          <h5>Lives todos os dias Ganhando Dinheiro Ao Vivo e ensinando na prática.</h5>
          <p>Clique no botão verde abaixo.</p>
          <button 
            onClick={openExternalLink} 
            style={{backgroundColor:'green', fontSize:'20px'}}
          >
            ENTRAR
          </button>
          <p></p>
          <button 
            onClick={closePopup} 
            style={{backgroundColor:'red', fontSize:'10px'}}
          >
            Fechar
          </button>
        </div>
      </div>
    </>
  );
};

export default PopupModal;
